module.exports = __webpack_public_path__ + "img/bg.689441cd.jpg";